import { motion } from "framer-motion";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { PricingCard } from "@/components/pricing/PricingCard";
import { SEO } from "@/components/SEO";

const plans = [
  {
    name: "NORMAL",
    price: 99,
    currency: "RON",
    period: "lună",
    description: "Pentru site-uri mici și mijlocii",
    features: [
      "Optimizare automată (500 pagini/lună)",
      "Moduri 1-2 (Meta, Schema, Smart Expand)",
      "Scan zilnic trenduri Google",
      "Backup & Undo automat",
      "Rapoarte săptămânale",
      "Suport email",
    ],
    isPopular: false,
  },
  {
    name: "ULTRA",
    price: 249,
    currency: "RON",
    period: "lună",
    description: "Pentru afaceri serioase",
    features: [
      "Optimizare Nelimitată",
      "Modul 3 (Rescriere totală & Blog)",
      "Analiză Concurență detaliată",
      "Strategii de citare în ChatGPT",
      "Analytics Avansat (ROI estimat)",
      "Suport Prioritar RO 24/7",
      "Onboarding personalizat",
      "API Access",
    ],
    isPopular: true,
  },
];

const Pricing = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Prețuri"
        description="Planuri flexibile pentru optimizare SEO + GEO. De la 99 RON/lună. Garanție 14 zile cu banii înapoi."
        canonical="https://optiro.ai/pricing"
      />
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-4">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-2xl mx-auto mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
              Prețuri Simple,{" "}
              <span className="text-gradient">Rezultate Reale</span>
            </h1>
            <p className="text-lg text-muted-foreground">
              Alege planul potrivit pentru afacerea ta. Toate planurile includ
              garanție de 14 zile cu banii înapoi.
            </p>
          </motion.div>

          {/* Pricing Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {plans.map((plan, index) => (
              <PricingCard key={plan.name} {...plan} index={index} />
            ))}
          </div>

          {/* FAQ or Trust Section */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="mt-20 text-center"
          >
            <p className="text-muted-foreground mb-4">
              Ai întrebări? Scrie-ne la{" "}
              <a
                href="mailto:contactoptiro@gmail.com"
                className="text-primary hover:underline"
              >
                contactoptiro@gmail.com
              </a>
            </p>
            <div className="flex flex-wrap justify-center gap-8 text-sm text-muted-foreground">
              <span>✓ Fără contracte pe termen lung</span>
              <span>✓ Anulare oricând</span>
              <span>✓ Facturare în RON</span>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
